import { getAppVersion, compareVersion } from 'root/common/util/getAppVersion';

function getLoginState() {
    let loginState = localStorage.getItem('token') ? true : false;
    return loginState;
}
export default getLoginState;

export const isNewVersion = function() {
    if (compareVersion(getAppVersion(), '1.25.0') == -1 || !window.__is_blackApp) {
        return false;
    }

    return true;
};
